import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../../security/service-app.service';
import { IFiltros, ITotaisHistorico } from '../interface-apuracao-vdm-peca';
import { ApuracaoVdmPecaService, ApuracaoVdmData } from '../apuracao-vdm-peca.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-apuracao-vdm-historico-peca',
  templateUrl: './apuracao-vdm-historico-peca.component.html',
  styleUrls: ['./apuracao-vdm-historico-peca.component.scss']
})
export class ApuracaoVdmHistoricoPecaComponent implements OnInit, OnDestroy {
  cols: any[];
  frozenCols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;
  private subscription: Subscription = new Subscription();

  totaisHistorico: ITotaisHistorico = {
    filtroAno: 0,
    totalAbrGap: 0,
    totalAbrObjetivo: 0,
    totalAbrPercent: 0,
    totalAbrRealizado: 0,
    totalAgoGap: 0,
    totalAgoObjetivo: 0,
    totalAgoPercent: 0,
    totalAgoRealizado: 0,
    totalDezGap: 0,
    totalDezObjetivo: 0,
    totalDezPercent: 0,
    totalDezRealizado: 0,
    totalFevGap: 0,
    totalFevObjetivo: 0,
    totalFevPercent: 0,
    totalFevRealizado: 0,
    totalJanGap: 0,
    totalJanObjetivo: 0,
    totalJanPercent: 0,
    totalJanRealizado: 0,
    totalJulGap: 0,
    totalJulObjetivo: 0,
    totalJulPercent: 0,
    totalJulRealizado: 0,
    totalJunGap: 0,
    totalJunObjetivo: 0,
    totalJunPercent: 0,
    totalJunRealizado: 0,
    totalMaiGap: 0,
    totalMaiObjetivo: 0,
    totalMaiPercent: 0,
    totalMaiRealizado: 0,
    totalMarGap: 0,
    totalMarObjetivo: 0,
    totalMarPercent: 0,
    totalMarRealizado: 0,
    totalNovGap: 0,
    totalNovObjetivo: 0,
    totalNovPercent: 0,
    totalNovRealizado: 0,
    totalOutGap: 0,
    totalOutObjetivo: 0,
    totalOutPercent: 0,
    totalOutRealizado: 0,
    totalQ1Gap: 0,
    totalQ1Objetivo: 0,
    totalQ1Percent: 0,
    totalQ1Realizado: 0,
    totalQ2Gap: 0,
    totalQ2Objetivo: 0,
    totalQ2Percent: 0,
    totalQ2Realizado: 0,
    totalQ3Gap: 0,
    totalQ3Objetivo: 0,
    totalQ3Percent: 0,
    totalQ3Realizado: 0,
    totalQ4Gap: 0,
    totalQ4Objetivo: 0,
    totalQ4Percent: 0,
    totalQ4Realizado: 0,
    totalSetGap: 0,
    totalSetObjetivo: 0,
    totalSetPercent: 0,
    totalSetRealizado: 0,
  }

  @Input() filtros: IFiltros;
  @ViewChild('dt') dt: Table;
  
  constructor(
    private service: ServiceAppService,
    private apuracaoVdmService: ApuracaoVdmPecaService
  ) { }

  ngOnInit(): void {
    this.inicializarColunas();
    this.subscribeToData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private inicializarColunas() {
    this.cols = [
      { field: 'b_codDealer', header: 'Dealer', width: 'width:120px' },
      { field: 'c_nomeDealer', header: 'Nome', width: 'width:180px' },
      { field: 'abrRealizado', header: 'Realizado / Abr', width: 'width:142px' },
      { field: 'abrObjetivo', header: 'Objetivo / Abr', width: 'width:135px' },
      { field: 'abrGap', header: 'Gap / Abr', width: 'width:120px' },
      { field: 'abrPercent', header: '% / Abr', width: 'width:120px' },
      { field: 'maiRealizado', header: 'Realizado / Mai', width: 'width:142px' },
      { field: 'maiObjetivo', header: 'Objetivo / Mai', width: 'width:135px' },
      { field: 'maiGap', header: 'Gap / Mai', width: 'width:120px' },
      { field: 'maiPercent', header: '% / Mai', width: 'width:120px' },
      { field: 'junRealizado', header: 'Realizado / Jun', width: 'width:142px' },
      { field: 'junObjetivo', header: 'Objetivo / Jun', width: 'width:135px' },
      { field: 'junGap', header: 'Gap / Jun', width: 'width:120px' },
      { field: 'junPercent', header: '% / Jun', width: 'width:120px' },
      { field: 'q1Realizado', header: 'Realizado / Q1', width: 'width:142px' },
      { field: 'q1Objetivo', header: 'Objetivo / Q1', width: 'width:135px' },
      { field: 'q1Gap', header: 'Gap / Q1', width: 'width:120px' },
      { field: 'q1Percent', header: '% / Q1', width: 'width:120px' },
      { field: 'julRealizado', header: 'Realizado / Jul', width: 'width:142px' },
      { field: 'julObjetivo', header: 'Objetivo / Jul', width: 'width:135px' },
      { field: 'julGap', header: 'Gap / Jul', width: 'width:120px' },
      { field: 'julPercent', header: '% / Jul', width: 'width:120px' },
      { field: 'agoRealizado', header: 'Realizado / Ago', width: 'width:145px' },
      { field: 'agoObjetivo', header: 'Objetivo / Ago', width: 'width:140px' },
      { field: 'agoGap', header: 'Gap / Ago', width: 'width:120px' },
      { field: 'agoPercent', header: '% / Ago', width: 'width:120px' },
      { field: 'setRealizado', header: 'Realizado / Set', width: 'width:142px' },
      { field: 'setObjetivo', header: 'Objetivo / Set', width: 'width:135px' },
      { field: 'setGap', header: 'Gap / Set', width: 'width:120px' },
      { field: 'setPercent', header: '% / Set', width: 'width:120px' },
      { field: 'q2Realizado', header: 'Realizado / Q2', width: 'width:142px' },
      { field: 'q2Objetivo', header: 'Objetivo / Q2', width: 'width:135px' },
      { field: 'q2Gap', header: 'Gap / Q2', width: 'width:120px' },
      { field: 'q2Percent', header: '% / Q2', width: 'width:120px' },
      { field: 'outRealizado', header: 'Realizado / Out', width: 'width:142px' },
      { field: 'outObjetivo', header: 'Objetivo / Out', width: 'width:135px' },
      { field: 'outGap', header: 'Gap / Out', width: 'width:120px' },
      { field: 'outPercent', header: '% / Out', width: 'width:120px' },
      { field: 'novRealizado', header: 'Realizado / Nov', width: 'width:145px' },
      { field: 'novObjetivo', header: 'Objetivo / Nov', width: 'width:140px' },
      { field: 'novGap', header: 'Gap / Nov', width: 'width:120px' },
      { field: 'novPercent', header: '% / Nov', width: 'width:120px' },
      { field: 'dezRealizado', header: 'Realizado / Dez', width: 'width:142px' },
      { field: 'dezObjetivo', header: 'Objetivo / Dez', width: 'width:135px' },
      { field: 'dezGap', header: 'Gap / Dez', width: 'width:120px' },
      { field: 'dezPercent', header: '% / Dez', width: 'width:120px' },
      { field: 'q3Realizado', header: 'Realizado / Q3', width: 'width:142px' },
      { field: 'q3Objetivo', header: 'Objetivo / Q3', width: 'width:135px' },
      { field: 'q3Gap', header: 'Gap / Q3', width: 'width:120px' },
      { field: 'q3Percent', header: '% / Q3', width: 'width:120px' },
      { field: 'janRealizado', header: 'Realizado / Jan', width: 'width:142px' },
      { field: 'janObjetivo', header: 'Objetivo / Jan', width: 'width:135px' },
      { field: 'janGap', header: 'Gap / Jan', width: 'width:120px' },
      { field: 'janPercent', header: '% / Jan', width: 'width:120px' },
      { field: 'fevRealizado', header: 'Realizado / Fev', width: 'width:142px' },
      { field: 'fevObjetivo', header: 'Objetivo / Fev', width: 'width:135px' },
      { field: 'fevGap', header: 'Gap / Fev', width: 'width:120px' },
      { field: 'fevPercent', header: '% / Fev', width: 'width:120px' },
      { field: 'marRealizado', header: 'Realizado / Mar', width: 'width:145px' },
      { field: 'marObjetivo', header: 'Objetivo / Mar', width: 'width:140px' },
      { field: 'marGap', header: 'Gap / Mar', width: 'width:120px' },
      { field: 'marPercent', header: '% / Mar', width: 'width:120px' },
      { field: 'q4Realizado', header: 'Realizado / Q4', width: 'width:142px' },
      { field: 'q4Objetivo', header: 'Objetivo / Q4', width: 'width:135px' },
      { field: 'q4Gap', header: 'Gap / Q4', width: 'width:120px' },
      { field: 'q4Percent', header: '% / Q4', width: 'width:120px' },
    ];

    // Definindo colunas congeladas
    this.frozenCols = [
      { field: 'b_codDealer', header: 'Dealer' },
      { field: 'c_nomeDealer', header: 'Nome' }
    ];
  }

  private subscribeToData() {
    this.subscription.add(
      this.apuracaoVdmService.data$.subscribe(data => {
        if (data) {
          this.dados = data.dados;
          this.totaisHistorico = data.totaisHistorico;
        }
      })
    );

    this.subscription.add(
      this.apuracaoVdmService.loading$.subscribe(loading => {
        this.loading = loading;
      })
    );
  }

  retornaDados() {
    // Este método agora é chamado pelo componente pai
    // Os dados são atualizados automaticamente via subscription
  }

  /**
   * Método chamado pelo componente pai para atualizar os dados
   */
  atualizarDados(data: ApuracaoVdmData) {
    this.dados = data.dados;
    this.totaisHistorico = data.totaisHistorico;
  }
}